import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import ErrorBoundary from '../../molecules/ErrorBoundary'
import FormattingProvider from '../../organisms/FormattingProvider'
import { useHideSideMenuEffect } from '../../../redux/slices/appContext'
import NotAvailable from '../../organisms/NotAvailable'
import { useIsDenaliActive } from '../../../hooks/featureChecks'
import IndexView from './IndexView'
import IntegratorHome from './Integrator/IntegratorHome'
import AlertsHome from './Alerts/AlertsHome'
import AnalysisHome from './Analysis/AnalysisHome'
import IngestionHome from './Ingestion/IngestionHome'
import OrchestratorHome from './Orchestrator/OrchestratorHome'
import IntegrationDomains from './Integrator/Domains'
import SourceDetails from './Integrator/SourceDetails'
import IntegrationJobs from './Integrator/IntegrationJobs'
import JobDetails from './Integrator/JobDetails'
import BatchList from './Integrator/BatchList'
import BatchDetails from './Integrator/BatchDetails'
import DenaliProvider from './DenaliProvider'
import QueryHome from './Integrator/Query'

const DenaliIndex = () => {
  const { path } = useRouteMatch()
  useHideSideMenuEffect([])
  const isDenaliActive = useIsDenaliActive()

  if (!isDenaliActive) {
    return <NotAvailable />
  }

  return (
    <ErrorBoundary name='Denali'>
      <FormattingProvider>
        <DenaliProvider>
          <Switch>
            <SecureRoute path={path} exact>
              <IndexView root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/alerts`} exact>
              <AlertsHome root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/analysis`} exact>
              <AnalysisHome root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/ingestion`} exact>
              <IngestionHome root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator`} exact>
              <IntegratorHome root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/domains`} exact>
              <IntegrationDomains root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/domains/:domain/sources/:sourceKey`} exact>
              <SourceDetails root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/domains/:domain/jobs/:jobKey`} exact>
              <JobDetails root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/domains/:domain/jobs/:jobKey/query`} exact>
              <QueryHome root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/jobs`} exact>
              <IntegrationJobs root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/batches`} exact>
              <BatchList root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/integrator/batches/:batchId`} exact>
              <BatchDetails root={path} />
            </SecureRoute>
            <SecureRoute path={`${path}/orchestration`} exact>
              <OrchestratorHome root={path} />
            </SecureRoute>
          </Switch>
        </DenaliProvider>
      </FormattingProvider>
    </ErrorBoundary>
  )
}

export default DenaliIndex
